export const phoneCode = {
  'US': '+1',
  'RU': '+7',
  'EG': '+20',
  'ZA': '+27',
  'GR': '+30',
  'NL': '+31',
  'BE': '+32',
  'FR': '+33',
  'ES': '+34',
  'HU': '+36',
  'IT': '+39',
  'RO': '+40',
  'CH': '+41',
  'AT': '+43',
  'GB': '+44',
  'DK': '+45',
  'SE': '+46',
  'NO': '+47',
  'PL': '+48',
  'DE': '+49',
  'PE': '+51',
  'MX': '+52',
  'CU': '+53',
  'AR': '+54',
  'BR': '+55',
  'CL': '+56',
  'CO': '+57',
  'VE': '+58',
  'MY': '+60',
  'AU': '+61',
  'ID': '+62',
  'PH': '+63',
  'NZ': '+64',
  'SG': '+65',
  'TH': '+66',
  'JP': '+81',
  'KR': '+82',
  'VN': '+84',
  'CN': '+86',
  'TR': '+90',
  'IN': '+91',
  'PK': '+92',
  'AF': '+93',
  'LK': '+94',
  'MM': '+95',
  'IR': '+98',
  'SS': '+211',
  'MA': '+212',
  'DZ': '+213',
  'TN': '+216',
  'LY': '+218',
  'GM': '+220',
  'SN': '+221',
  'MR': '+222',
  'ML': '+223',
  'GN': '+224',
  'CI': '+225',
  'BF': '+226',
  'NE': '+227',
  'TG': '+228',
  'BJ': '+229',
  'MU': '+230',
  'LR': '+231',
  'SL': '+232',
  'GH': '+233',
  'NG': '+234',
  'TD': '+235',
  'CF': '+236',
  'CM': '+237',
  'CV': '+238',
  'ST': '+239',
  'GQ': '+240',
  'GA': '+241',
  'CG': '+242',
  'CD': '+243',
  'AO': '+244',
  'GW': '+245',
  'SC': '+248',
  'SD': '+249',
  'RW': '+250',
  'ET': '+251',
  'SO': '+252',
  'DJ': '+253',
  'KE': '+254',
  'TZ': '+255',
  'UG': '+256',
  'BI': '+257',
  'MZ': '+258',
  'ZM': '+260',
  'MG': '+261',
  'RE': '+262',
  'ZW': '+263',
  'NA': '+264',
  'MW': '+265',
  'LS': '+266',
  'BW': '+267',
  'SZ': '+268',
  'KM': '+269',
  'SH': '+290',
  'ER': '+291',
  'AW': '+297',
  'FO': '+298',
  'GL': '+299',
  'GI': '+350',
  'PT': '+351',
  'LU': '+352',
  'IE': '+353',
  'IS': '+354',
  'AL': '+355',
  'MT': '+356',
  'CY': '+357',
  'FI': '+358',
  'BG': '+359',
  'LT': '+370',
  'LV': '+371',
  'EE': '+372',
  'MD': '+373',
  'AM': '+374',
  'BY': '+375',
  'AD': '+376',
  'MC': '+377',
  'SM': '+378',
  'VA': '+379',
  'UA': '+380',
  'RS': '+381',
  'ME': '+382',
  'XK': '+383',
  'HR': '+385',
  'SI': '+386',
  'BA': '+387',
  'MK': '+389',
  'CZ': '+420',
  'SK': '+421',
  'LI': '+423',
  'FK': '+500',
  'BZ': '+501',
  'GT': '+502',
  'SV': '+503',
  'HN': '+504',
  'NI': '+505',
  'CR': '+506',
  'PA': '+507',
  'PM': '+508',
  'HT': '+509',
  'GP': '+590',
  'BO': '+591',
  'GY': '+592',
  'EC': '+593',
  'GF': '+594',
  'PY': '+595',
  'MQ': '+596',
  'SR': '+597',
  'UY': '+598',
  'CW': '+599',
  'TL': '+670',
  'NF': '+672',
  'BN': '+673',
  'NR': '+674',
  'PG': '+675',
  'TO': '+676',
  'SB': '+677',
  'VU': '+678',
  'FJ': '+679',
  'PW': '+680',
  'WF': '+681',
  'CK': '+682',
  'NU': '+683',
  'WS': '+685',
  'KI': '+686',
  'NC': '+687',
  'TV': '+688',
  'PF': '+689',
  'TK': '+690',
  'FM': '+691',
  'MH': '+692',
  'KP': '+850',
  'HK': '+852',
  'MO': '+853',
  'KH': '+855',
  'LA': '+856',
  'BD': '+880',
  'MV': '+960',
  'LB': '+961',
  'JO': '+962',
  'SY': '+963',
  'IQ': '+964',
  'KW': '+965',
  'SA': '+966',
  'YE': '+967',
  'OM': '+968',
  'PS': '+970',
  'AE': '+971',
  'IL': '+972',
  'BH': '+973',
  'QA': '+974',
  'BT': '+975',
  'MN': '+976',
  'NP': '+977',
  'TJ': '+992',
  'TM': '+993',
  'AZ': '+994',
  'GE': '+995',
  'KG': '+996',
  'UZ': '+998'
}



export const swappedPhoneCode = {
  '+1': 'US',
  '+7': 'RU',
  '+20': 'EG',
  '+27': 'ZA',
  '+30': 'GR',
  '+31': 'NL',
  '+32': 'BE',
  '+33': 'FR',
  '+34': 'ES',
  '+36': 'HU',
  '+39': 'IT',
  '+40': 'RO',
  '+41': 'CH',
  '+43': 'AT',
  '+44': 'GB',
  '+45': 'DK',
  '+46': 'SE',
  '+47': 'NO',
  '+48': 'PL',
  '+49': 'DE',
  '+51': 'PE',
  '+52': 'MX',
  '+53': 'CU',
  '+54': 'AR',
  '+55': 'BR',
  '+56': 'CL',
  '+57': 'CO',
  '+58': 'VE',
  '+60': 'MY',
  '+61': 'AU',
  '+62': 'ID',
  '+63': 'PH',
  '+64': 'NZ',
  '+65': 'SG',
  '+66': 'TH',
  '+81': 'JP',
  '+82': 'KR',
  '+84': 'VN',
  '+86': 'CN',
  '+90': 'TR',
  '+91': 'IN',
  '+92': 'PK',
  '+93': 'AF',
  '+94': 'LK',
  '+95': 'MM',
  '+98': 'IR',
  '+211': 'SS',
  '+212': 'MA',
  '+213': 'DZ',
  '+216': 'TN',
  '+218': 'LY',
  '+220': 'GM',
  '+221': 'SN',
  '+222': 'MR',
  '+223': 'ML',
  '+224': 'GN',
  '+225': 'CI',
  '+226': 'BF',
  '+227': 'NE',
  '+228': 'TG',
  '+229': 'BJ',
  '+230': 'MU',
  '+231': 'LR',
  '+232': 'SL',
  '+233': 'GH',
  '+234': 'NG',
  '+235': 'TD',
  '+236': 'CF',
  '+237': 'CM',
  '+238': 'CV',
  '+239': 'ST',
  '+240': 'GQ',
  '+241': 'GA',
  '+242': 'CG',
  '+243': 'CD',
  '+244': 'AO',
  '+245': 'GW',
  '+248': 'SC',
  '+249': 'SD',
  '+250': 'RW',
  '+251': 'ET',
  '+252': 'SO',
  '+253': 'DJ',
  '+254': 'KE',
  '+255': 'TZ',
  '+256': 'UG',
  '+257': 'BI',
  '+258': 'MZ',
  '+260': 'ZM',
  '+261': 'MG',
  '+262': 'RE',
  '+263': 'ZW',
  '+264': 'NA',
  '+265': 'MW',
  '+266': 'LS',
  '+267': 'BW',
  '+268': 'SZ',
  '+269': 'KM',
  '+290': 'SH',
  '+291': 'ER',
  '+297': 'AW',
  '+298': 'FO',
  '+299': 'GL',
  '+350': 'GI',
  '+351': 'PT',
  '+352': 'LU',
  '+353': 'IE',
  '+354': 'IS',
  '+355': 'AL',
  '+356': 'MT',
  '+357': 'CY',
  '+358': 'FI',
  '+359': 'BG',
  '+370': 'LT',
  '+371': 'LV',
  '+372': 'EE',
  '+373': 'MD',
  '+374': 'AM',
  '+375': 'BY',
  '+376': 'AD',
  '+377': 'MC',
  '+378': 'SM',
  '+379': 'VA',
  '+380': 'UA',
  '+381': 'RS',
  '+382': 'ME',
  '+383': 'XK',
  '+385': 'HR',
  '+386': 'SI',
  '+387': 'BA',
  '+389': 'MK',
  '+420': 'CZ',
  '+421': 'SK',
  '+423': 'LI',
  '+500': 'FK',
  '+501': 'BZ',
  '+502': 'GT',
  '+503': 'SV',
  '+504': 'HN',
  '+505': 'NI',
  '+506': 'CR',
  '+507': 'PA',
  '+508': 'PM',
  '+509': 'HT',
  '+590': 'GP',
  '+591': 'BO',
  '+592': 'GY',
  '+593': 'EC',
  '+594': 'GF',
  '+595': 'PY',
  '+596': 'MQ',
  '+597': 'SR',
  '+598': 'UY',
  '+599': 'CW',
  '+670': 'TL',
  '+672': 'NF',
  '+673': 'BN',
  '+674': 'NR',
  '+675': 'PG',
  '+676': 'TO',
  '+677': 'SB',
  '+678': 'VU',
  '+679': 'FJ',
  '+680': 'PW',
  '+681': 'WF',
  '+682': 'CK',
  '+683': 'NU',
  '+685': 'WS',
  '+686': 'KI',
  '+687': 'NC',
  '+688': 'TV',
  '+689': 'PF',
  '+690': 'TK',
  '+691': 'FM',
  '+692': 'MH',
  '+850': 'KP',
  '+852': 'HK',
  '+853': 'MO',
  '+855': 'KH',
  '+856': 'LA',
  '+880': 'BD',
  '+960': 'MV',
  '+961': 'LB',
  '+962': 'JO',
  '+963': 'SY',
  '+964': 'IQ',
  '+965': 'KW',
  '+966': 'SA',
  '+967': 'YE',
  '+968': 'OM',
  '+970': 'PS',
  '+971': 'AE',
  '+972': 'IL',
  '+973': 'BH',
  '+974': 'QA',
  '+975': 'BT',
  '+976': 'MN',
  '+977': 'NP',
  '+992': 'TJ',
  '+993': 'TM',
  '+994': 'AZ',
  '+995': 'GE',
  '+996': 'KG',
  '+998': 'UZ'
};
